/// <reference path="../shims.d.ts" />
// Layered top-down auto-layout for flow graphs via dagre. Called once per
// flow load; the result feeds @xyflow/react as initial node positions. We
// don't run dagre on every render — the graph is static V1.

import dagre from 'dagre'
import { NODE_HEIGHT, NODE_WIDTH } from './flow-parse.js'

const RANK_SEP = 80
const NODE_SEP = 40

/**
 * @param {ReturnType<import('./flow-parse.js').parseFlowYaml>['nodes']} nodes
 * @param {ReturnType<import('./flow-parse.js').parseFlowYaml>['edges']} edges
 * @returns {{ nodes: any[], edges: any[] }}
 */
export function layoutFlow(nodes, edges) {
  const g = new dagre.graphlib.Graph()
  g.setDefaultEdgeLabel(() => ({}))
  g.setGraph({ rankdir: 'TB', ranksep: RANK_SEP, nodesep: NODE_SEP, marginx: 24, marginy: 24 })

  for (const node of nodes) {
    g.setNode(node.id, { width: NODE_WIDTH, height: NODE_HEIGHT })
  }
  for (const edge of edges) {
    g.setEdge(edge.source, edge.target)
  }

  dagre.layout(g)

  const positionedNodes = nodes.map((node) => {
    const { x, y } = g.node(node.id) ?? { x: 0, y: 0 }
    return {
      ...node,
      position: { x: x - NODE_WIDTH / 2, y: y - NODE_HEIGHT / 2 },
      sourcePosition: 'bottom',
      targetPosition: 'top',
    }
  })

  return { nodes: positionedNodes, edges }
}
